import { bankAccountNumberActionItems } from '../../domain/bankaccountnumber/BankAccountNumberActionItems';
import { categoryActionItems } from '../../domain/bill/category/CategoryActionItems';
import { customerActionItems } from '../../domain/bill/customer/CustomerActionItems';
import { incomingBillActionItems } from '../../domain/bill/incomingbill/IncomingBillActionItems';
import { outgoingBillActionItems } from '../../domain/bill/outgoingbill/OutgoingBillActionItems';
import { employeeActionItems } from '../../domain/salary/employee/EmployeeActionItems';
import { availableVacationActionItems } from '../../domain/salary/vacation/availablevacation/AvailableVacationActionItems';
import { occasionalSalaryActionItems } from '../../domain/salary/salary/occasionalsalary/OccasionalSalaryActionItems';
import { restrainPartnerActionItems } from '../../domain/salary/restrain/restrainpartner/RestrainPartnerActionItems';
import { restrainActionItems } from '../../domain/salary/restrain/restrain/RestrainActionItems';
import { salaryActionItems } from '../../domain/salary/salary/salary/SalaryActionItems';
import { vacationActionItems } from '../../domain/salary/vacation/vacation/VacationActionItems';
import { taxTypeActionItems } from '../../domain/tax/taxtype/TaxTypeActionItems';
import { taxActionItems } from '../../domain/tax/tax/TaxActionItems';
import { projectActionItems } from '../../domain/bill/project/ProjectActionItems';
import { cashActionItems } from '../../domain/cash/CashActionItems';
import { balanceActionItems } from '../../domain/balance/BalanceActionItems';
import { linkActionItems } from '../../domain/link/LinkActionItems';
import { bankActionItems } from '../../domain/bank/BankActionItems';
import { closeActionItems } from '../../domain/close/CloseActionItems';
import { availableDividendActionItems } from '../../domain/salary/dividend/availabledividend/AvailableDividendActionItems';
import { dividendActionItems } from '../../domain/salary/dividend/dividend/DividendActionItems';
import { carActionItems } from '../../domain/car/car/CarActionItems';
import { carDayActionItems } from '../../domain/car/carday/CarDayAction';
import { carDayLocationActionItems } from '../../domain/car/carday/CarDayLocationAction';

export const actionMap = new Map([
    ["outgoingbill", outgoingBillActionItems],
    ["incomingbill", incomingBillActionItems],
    ["salary", salaryActionItems],
    ["employee", employeeActionItems],
    ["occasionalsalary", occasionalSalaryActionItems],
    ["restrainpartner", restrainPartnerActionItems],
    ["bankaccountnumber", bankAccountNumberActionItems],
    ["customer", customerActionItems],
    ["category", categoryActionItems],
    ["taxtype", taxTypeActionItems],
    ["tax", taxActionItems],
    ["restrain", restrainActionItems],
    ["project", projectActionItems],
    ["cash", cashActionItems],
    ["balance", balanceActionItems],
    ["link", linkActionItems],
    ["bank", bankActionItems],
    ["close", closeActionItems],
    ["availablevacation", availableVacationActionItems],
    ["vacation", vacationActionItems],
    ["availabledividend", availableDividendActionItems],
    ["dividend", dividendActionItems],
    ["car", carActionItems],
    ["carday", carDayActionItems],
    ["cardaylocation", carDayLocationActionItems]
]);
